import axiosInstance from './client';
import {
  Response,
  EventDto,
  TemplateUpdateDto,
  TriggerNotificationDto,
  NotificationHtmlDto,
  TemplateDto,
  EmailCategoryDto,
  ClientDto,
  EventTemplateMapFullView,
  EmailCategoryResponseDto,
  emailsEventRoute,
  emailsTemplate,
  emailsTemplateDetail
} from '../../../submission-service/src/endpoints/emails/response-types';

export type {
  TemplateUpdateDto,
  EventDto,
  TriggerNotificationDto,
  NotificationHtmlDto,
  TemplateDto,
  ClientDto,
  EventTemplateMapFullView,
  EmailCategoryResponseDto
};

export function sendTestEmail(
  organizationId: string,
  emailContent: {
    subject: string;
    body: string;
    recipients: {
      to: string;
      cc: never[];
      bcc: never[];
    };
    attachments?: { name: string; url: string }[];
  }
) {
  return axiosInstance
    .post<unknown>(
      `/email-service/organizations/${organizationId}/send-test`,
      emailContent
    )
    .then(r => r.data);
}

export function listEvents(
  clientId: number,
  searchEvent?: string,
  page?: number,
  size?: number
) {
  return axiosInstance
    .get<{ list: EventDto[]; total: number }>(emailsEventRoute.path, {
      params: {
        clientid: clientId,
        searchEvent,
        page,
        size
      }
    })
    .then(r => r.data);
}

export function getEventTemplateMappings(
  organizationId: string,
  clientId: string,
  query?: string,
  categories?: number,
  page?: number,
  size?: number
) {
  return axiosInstance
    .get<{
      list: {
        categoryId: number;
        categoryName: string;
        eventName: string;
        eventid: number;
        id: string;
        templateId: number;
        templateName: string;
      }[];
      total: number;
    }>(
      emailsTemplate.build({
        organizationId,
        clientId
      }),
      {
        params: {
          query,
          categories,
          page,
          size
        }
      }
    )
    .then(r => r.data);
}

export function getEventTemplateFullDetails(
  organizationId: string,
  clientId: string,
  eventTemplateId: string
) {
  return axiosInstance
    .get<EventTemplateMapFullView>(
      emailsTemplateDetail.build({
        organizationId,
        clientId,
        eventTemplateId
      })
    )
    .then(r => r.data);
}

export function editTemplate(
  organizationId: string,
  clientId: string,
  eventTemplateId: string,
  body: TemplateUpdateDto
) {
  return axiosInstance
    .put<Response>(
      emailsTemplateDetail.build({
        organizationId,
        clientId,
        eventTemplateId
      }),
      body
    )
    .then(r => r.data);
}

export function createTemplate(
  organizationId: string,
  clientId: string,
  body: TemplateUpdateDto
) {
  return axiosInstance
    .post<Response>(
      emailsTemplate.build({
        organizationId,
        clientId
      }),

      body
    )
    .then(r => r.data);
}

export function addEmailCategory(
  organizationId: string,
  body: EmailCategoryDto
) {
  return axiosInstance
    .post<Response>(`/emails/${organizationId}/email-category/add`, body)
    .then(r => r.data);
}

export function listEmailCategories(organizationId: string) {
  return axiosInstance
    .get<EmailCategoryResponseDto[]>(
      `emails/${organizationId}/email-category/categories`
    )
    .then(r => r.data);
}

export function addClient(body: ClientDto) {
  return axiosInstance
    .post<Response>(`/emails/client/add`, body)
    .then(r => r.data);
}
